import {getShowPrice} from "./priceFunctions";

/**
 * Whether bundle products (cart items with a `bundleParentId` pointing at another cart item) should be shown.
 * `receiptSettings.hideBundles` only hides bundles while prices are also hidden from the user - if prices are
 * showing, bundles stay visible even with `hideBundles` on.
 * @param fabricatorData {any}
 * @return {boolean}
 */
export function allowShowBundleProducts(fabricatorData: any): boolean {
  if (fabricatorData && fabricatorData.receiptSettings && fabricatorData.receiptSettings.hideBundles) {
    const showPrices = getShowPrice(fabricatorData);
    return showPrices; // if the prices are hidden we should also hide bundles if hideBundles is on
  }
  return true;
}
